module.exports = {"623001001":"当周街道","623001002":"伊合昂街道","623001003":"坚木克尔街道","623001004":"通钦街道","623001100":"那吾镇","623001101":"勒秀镇","623001102":"佐盖曼玛镇","623001200":"卡加曼乡","623001201":"卡加道乡","623001202":"佐盖多玛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623001.json
// module id = 3110
// module chunks = 0